import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEY_ADM_TENANT_DETAILS } from "Data/keys/QueryKeys";
import { AdmApi } from "Data/Adm.api";
import { ITenantAdm, ITenantAdmResponse } from "Data/interfaces/Tenant/ITenantAdm";

export const useQueryTenantDetails = (tenantId: number | null) => {
    const { data, refetch, isLoading, isFetching, error } = useQuery({
        queryKey: [QUERY_KEY_ADM_TENANT_DETAILS, tenantId],
        staleTime: 10 * 1000, // 10 seconds
        enabled: !!tenantId,
        queryFn: async () => {
            const { data } = await AdmApi.getTenantDetails(tenantId || 0);
            return data.data;
        },
    });

    const dataDefault = useMemo(() => ({} as ITenantAdm), []);

    return {
        data: data ?? dataDefault,
        refetch,
        isLoading,
        isFetching,
        error,
    }
};
